// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  seatUid: __t.string().primaryKey().name("seat_uid"),
  restaurantId: __t.u64().name("restaurant_id"),
  x: __t.f32(),
  z: __t.f32(),
  floor: __t.u32(),
  facingY: __t.f32().name("facing_y"),
  plateX: __t.f32().name("plate_x"),
  plateZ: __t.f32().name("plate_z"),
  atBar: __t.bool().name("at_bar"),
});
